export default {
  template: {
    title: 'Candidate Questionnaire Management',
    menu: 'Candidate Questionnaire Management',
    taskTitle: 'Question Update Task Management'
  },
  label: {
    group: 'Template',
    groupName: 'Template Name',
    questionType: 'Question Type',
    subQuestionType: 'Sub-Question Type',
    parentQuestion: 'Parent Question',
    triggerOption: 'Trigger Option',
    questionTitle: 'Title',
    requiredQuestion: 'Required question',
    includeKnockoutOptions: 'Include knockout options',
    createUpdateTask: 'Create update task',
    options: 'Options',
    allOptions: 'All Options',
    markAsKnockoutOptions: 'Mark as knockout option',
    unGrouped: 'Not in Template',
    duration: 'Duration',
    visibility: 'Visibility',
    templateName: 'Template Name',
    updateJobs: 'Updated Jobs',
    executeTime: 'Estimated Start Time',
    executeStatus: 'Status',
    finishTime: 'Finished Time',
    noJobs: 'None',
    taskStatus: {
      pending: 'Pending',
      executing: 'Executing',
      success: 'Success',
      failure: 'Failure'
    },
    status: 'Status',
    otherGroup: '———————— Not in Template ———————'
  },
  editor: {
    group: {
      title: {
        add: 'Add Template',
        edit: 'Edit Template'
      }
    },
    question: {
      title: {
        add: 'Add Question',
        edit: 'Edit Question'
      }
    },
    subQuestion: {
      title: { add: 'Add Sub-Question', edit: 'Edit Sub-Question' }
    }
  },
  questionType: {
    TEXT: 'Text Question',
    SELECT: 'Single-select Question',
    CHECKBOX: 'Multi-select Question',
    VIDEO: 'Video Question',
    ATTACHMENT: 'Attachment Question',
    SINGLE_SELECT: 'Dropdown List Question - Single-select',
    MULTIPLE_SELECT: ' Dropdown List Question - Multi-select',
    DATE: 'Date Format Question'
  },
  btn: {
    addGroup: 'Add New Template',
    addQuestion: 'Add New Question',
    addNewGroup: 'Add New Template',
    addNewQuestion: 'Add New Question',
    addSubQuestion: 'Add Sub-Question',
    moveQuestion: 'Move to',
    addQuestionFromTemplate: 'Add From Question Template',
    taskList: 'Task List',
    back: 'Back',
    questionOptions: {
      expand: 'Show Options',
      collapse: 'Hidden Options'
    },
    setChild: 'Add Sub-Question',
    changeChild: 'Change Child',
    removeChild: 'Remove Child'
  },
  placeholder: {
    questionTypeFilter: 'Select Type',
    groupFilter: 'Select Template',
    groupQuestionKeywordsFilter: 'Search question by title',
    options: 'Option 1\nOption 2\nOption 3\n...etc',
    markAsKnockoutOptions: 'Choice knockout options'
  },
  message: {
    unsupportedTemplateType: 'This question tree contains a type unavailable for this questionnaire.',
    selectChildWithRoot: 'Select the parent root to include this child question.',
    noSelectableTemplate: 'This group has no question trees available for this questionnaire.',
    deleteQuestionLabel: 'Delete question',

    notKnockoutOptionsTip: 'Input your response options, or paste from Excel.',
    knockoutOptionsTip: 'When the candidate answer with the "Options", their application will appear in the application list as normal. When the candidate answers with the "Knockout Options" their application will appear in the "Disqualified" status folder.',
    executeTime: 'It will be finished within around 10 minutes after start.',
    duplicateTitle: 'Oops, seems there are duplicated questions, please update and resubmit.',
    confirmEnable: {
      disable: 'Confirm to disable?',
      enable: 'Confirm to enable?'
    },
    confirmDeleteQuestion: 'Are you sure to delete this question?',
    confirmDeleteQuestionTree: 'Are you sure to delete this question and all of its child questions?',
    confirmRemoveChild: 'Are you sure you want to remove the relation between this option and its child question?',
    removeLinkedOptionFirst: 'This option has a child question. Remove the child relation before editing the option.',
    invalidTemplateTree: 'The template question tree is incomplete, cyclic, or exceeds the maximum depth. Fix it before adding.',
    treeDropInsideNotAllowed: 'Questions cannot be placed inside another question tree.',
    treeStatusChangeNotAllowed: 'A child question follows the root question status and cannot be changed separately.',
    fillQuestionRequired: 'Please fill in the question',
    questionNotFound: 'Question not found',
    noAvailableChildOption: 'No unused, non-knockout option is available for a sub-question.',
    subQuestionUnsupportedParent: 'Only single-select and dropdown single-select questions can have sub-questions.',
    subQuestionMaxDepth: 'This question tree has reached its maximum depth.',
    selectTriggerOptionRequired: 'Select a trigger option.',
    confirmDeleteQuestionCount: 'Delete this question tree? {count} question(s) will be deleted.',
    cycleDetected: 'Cycle detected in question tree'
  },
  questionTypeShort: {
    text: 'Text',
    dropdown: 'Single-select',
    single_select: 'Dropdown List Single-select',
    checkbox: 'Multi-select',
    multiple_select: 'Dropdown List Multi-select',
    video: 'Video',
    portfolio: 'Attachment',
    date: 'Date'
  },
  visibilityType: {
    IE: 'Internal & External',
    I: 'Internal Only',
    E: 'External Only'
  }
}
